import { render, staticRenderFns } from "./boleto.vue?vue&type=template&id=5f6fa74c&scoped=true"
import script from "./boleto.vue?vue&type=script&lang=js"
export * from "./boleto.vue?vue&type=script&lang=js"
import style0 from "./boleto.vue?vue&type=style&index=0&id=5f6fa74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6fa74c",
  null
  
)

export default component.exports